import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const bresbetColors: ThemeTailwindType = {
    '--primary': '323 83% 59%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '0 0% 100%',
};

const colorPalette: ColorPaletteType = {
    primary: '#051d49',
    secondary: '#ed3faa',
    tertiary: '#00ccb6',
    dark: '#060c18',
    shade1: '#ebe718',
    shade2: '#c6cbd7',
    shade3: '#d9e3ec',
    shade4: '#e3eaf1',
    shade5: '#edf2f6',
    shade6: '#efefef',
    textDark: '#111111',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.secondary,

        borderColor: colorPalette.secondary,
        borderColorSecondary: colorPalette.secondary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.secondary,
        txtColorTertiary: colorPalette.white,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.white,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade6,
        txtDefault: colorPalette.primary,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#04183d',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#ed3faa',
        buttonTxtColor: '#ffffff',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
